<bz-loading class="bmc-queueitem-retries__loading" size="xl" *ngIf="isLoadingJobs$ | async">
</bz-loading>
<div class="retries_table" [style.display]="dataQueueitems?'':'none'" *ngIf="!(isLoadingJobs$ | async)">
    <table class="bz-table ">
        <thead>
            <tr>
                <th *ngFor="let column of headers" class="bz-table__cell " title="{{column}}">
                    <div class="bz-table__col-title">
                        <span class="bz-space--inline-xs">{{column}}</span>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of items">
                <td class="bz-table__cell ">
                    <bzg-icon class="bmc-queueitem-retries__icon" [nameIcon]="'info'" (click)="openDetailModal(row)" [color]="'success'"></bzg-icon>
                </td>
                <td class="bz-table__cell">
                    <span>{{ row.QueueDefinition.Name }}</span>
                </td>
                <td class="bz-table__cell">
                    <div class="retries_table__status">
                        <bzg-icon class="bz-space--inset-xs" [nameIcon]="'warning'" [color]="'error'"></bzg-icon>
                        <span class="bz-space--inset-xs">{{row.Status}}</span>
                    </div>
                </td>
                <td class="bz-table__cell">
                    <span>{{row.Reference}}</span>
                </td>
                <td class="bz-table__cell">
                    <span>{{row.Priority}}</span>
                </td>
                <td class="bz-table__cell">
                    <span>{{row.CreationTime}}</span>
                </td>
                <td class="bz-table__cell">
                    <span>{{row.ProcessingException.Type}}</span>
                </td>
                <td class="bz-table__cell ">
                    <bzg-icon class="bmc-queueitem-retries__icon" [nameIcon]=" 'icon-refresh' " (click)="openConfirmModal(row)" [color]=" 'success' "></bzg-icon>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="bz-table-pagination" *ngIf="!(isLoadingJobs$ | async)">
    <bzg-paginator [pageIndex]="pageIndex" [pageSize]="pageSize" [totalItems]="totalItems" [pageSizeOptions]="[10, 30, 50, 100, 200, 500]" [showFirstLastButtons]="showFirstLastButtons" [hidePageSizeSelector]="hidePageSizeSelector" (paginationChanged)="onPaginationEvent($event)">
    </bzg-paginator>
</div>